import React from 'react'

import {
  Tooltip,
  Icon,
  InfoOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { formatMoneyValue } from '../formatter'
import { SUBSCRIPTION_PANEL_CONFIG } from './earningsDetailConfig'

const renderMoney = ({ value }) => `$${formatMoneyValue(value)}`

function SortableHeader({ label, tooltipContent }) {
  return (
    <span className="subscription-detail-panel__header-label">
      {label}
      <Tooltip content={tooltipContent} place="top">
        <Icon
          svgComponent={InfoOutlined}
          color="dark"
          size="small"
          className="subscription-detail-panel__header-info-icon"
        />
      </Tooltip>
    </span>
  )
}

SortableHeader.propTypes = {
  label: string.isRequired,
  tooltipContent: string.isRequired,
}

export const subscriptionColumns = [
  { key: 'model', header: 'Models', minWidth: '100px' },
  {
    key: 'monthlyEarnings',
    header: (
      <SortableHeader
        label="Monthly"
        tooltipContent={SUBSCRIPTION_PANEL_CONFIG.monthlyEarningsTooltip}
      />
    ),
    sortable: true,
    cell: renderMoney,
    minWidth: '120px',
  },
  {
    key: 'totalEarned',
    header: (
      <SortableHeader
        label="Total"
        tooltipContent={SUBSCRIPTION_PANEL_CONFIG.totalEarnedTooltip}
      />
    ),
    sortable: true,
    cell: renderMoney,
    minWidth: '110px',
  },
  { key: 'publishedDate', header: 'Publishing date', minWidth: '110px' },
  { key: 'optedInDate', header: 'Subscription opt-in date', minWidth: '140px' },
]
